import { useQuery } from '@tanstack/react-query';
import { useNavigate, useParams } from 'react-router-dom';
import { SidecarPanelList } from './sidecar/SidecarPanelList';
import { SidecarPanelChannel } from './sidecar/SidecarPanelChannel';
import { NovaWorkspace } from '../assistant/NovaWorkspace';
import { NOVA_DM_ID } from '../assistant/novaTurn';
import { getAiAgentSettings } from '../../services/cabinet/aiAgentSettings';
import { messagingPagePath } from '../../store/sidecarBehavior';

export function MessagingPage() {
  const { channelId } = useParams<{ channelId?: string }>();
  const navigate = useNavigate();
  const agent = useQuery({
    queryKey: ['cabinet', 'ai-agent'],
    queryFn: getAiAgentSettings,
    staleTime: 60_000,
  });
  const novaOpen = channelId === NOVA_DM_ID && agent.data?.enabled === true;

  return (
    <div className="h-full min-h-0 flex overflow-hidden bg-white">
      <aside className="w-[260px] shrink-0 border-r border-neutral-200 flex flex-col min-h-0 min-w-0">
        <SidecarPanelList
          selectedChannelId={channelId ?? null}
          hideWindowActions
          onSelectChannel={(id) => navigate(messagingPagePath(id))}
        />
      </aside>
      <section className="flex-1 min-w-0 min-h-0 flex flex-col">
        {novaOpen ? (
          <NovaWorkspace hideBack />
        ) : channelId ? (
          <SidecarPanelChannel channelId={channelId} hideBack />
        ) : (
          <div className="flex-1 flex items-center justify-center px-6 text-sm text-cime-text-muted text-center">
            Choisissez un salon ou un message direct
          </div>
        )}
      </section>
    </div>
  );
}
